import React from 'react'
import './screenshot.css'

import screen1 from '../../assets/screen-01.png';
import screen2 from '../../assets/screen-02.png';
import screen3 from '../../assets/screen-03.png';

const Screenshot = () => {
  return (
    <div className="screenshot__container section__padding">

      <div className="screenshot__content">
        <div className="screenshot__content-text">
          <h2>Automated Reports <br /> & Widget Alerts</h2>
          <p>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit.
            Elementum nisi aliquet volutpat pellentesque volutpat est.
            Sapien in etiam vitae nibh nunc mattis imperdiet sed nullam.
            Vitae et, tortor pulvinar risus pulvinar sit amet.
          </p>
        </div>
        <div className="screenshot__content-img">
          <img src={screen1} alt="screenshot" />
        </div>
      </div>

        <div className="screenshot__content">
        <div className="screenshot__content-text">
          <h2>Fully customizable to address your needs</h2>
          <p>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit.
            Elementum nisi aliquet volutpat pellentesque volutpat est.
            Sapien in etiam vitae nibh nunc mattis imperdiet sed nullam.
            Vitae et, tortor pulvinar risus pulvinar sit amet.
          </p>
        </div>
        <div className="screenshot__content-img">
          <img src={screen2} alt="screenshot" />
        </div>
      </div>

      <div className="screenshot__content">
        <div className="screenshot__content-text">
          <h2>Pre-built Dashboard Templates</h2>
          <p>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit.
            Elementum nisi aliquet volutpat pellentesque volutpat est.
            Sapien in etiam vitae nibh nunc mattis imperdiet sed nullam.
            Vitae et, tortor pulvinar risus pulvinar sit amet.
          </p>
        </div>
        <div className="screenshot__content-img">
          <img src={screen3} alt="screenshot" />
        </div>
      </div>

    </div>
  )
}

export default Screenshot
